module.exports = __webpack_public_path__ + "media/images/your_ad/your_ad_300-90bc6fd80ede797fd434663a87c1a40b.png";